<script>
  import { router } from '@inertiajs/svelte'
  
  let { errors = {}, notice = null } = $props();
  
  let email = $state('');
  
  function submit(event) {
    event.preventDefault();
    router.post('/invitation', {
      email
    });
  }
  
  // Helper for error display
  function hasError(field) {
    return errors[field] !== undefined;
  }
  
  function getErrorMessages() {
    const messages = [];
    for (const field in errors) {
      if (Array.isArray(errors[field])) {
        errors[field].forEach(message => {
          messages.push(`${field} ${message}`);
        });
      }
    }
    return messages;
  }
  
  // Count total errors
  function countErrors() {
    let count = 0;
    for (const field in errors) {
      if (Array.isArray(errors[field])) {
        count += errors[field].length;
      }
    }
    return count;
  }
</script>

<div class="invitation-container">
  {#if notice}
    <p class="notice">{notice}</p>
  {/if}

  <h1>Send invitation</h1>
  
  {#if Object.keys(errors).length > 0}
    <div class="error-summary">
      <h2>{countErrors()} {countErrors() === 1 ? 'error' : 'errors'} prohibited this user from being saved:</h2>
      
      <ul>
        {#each getErrorMessages() as message}
          <li>{message}</li>
        {/each}
      </ul>
    </div>
  {/if}
  
  <form onsubmit={submit}>
    <div class="form-group">
      <label for="email" class="form-label">Email</label>
      <!-- svelte-ignore a11y_autofocus -->
      <input 
        id="email" 
        type="email" 
        bind:value={email} 
        required 
        autofocus 
        class={hasError('email') ? 'form-input error' : 'form-input'}
      />
      {#if hasError('email')}
        <div class="error-message">{errors.email.join(', ')}</div>
      {/if}
    </div>
    
    <div class="form-actions">
      <button type="submit" class="invitation-button">Send an invitation</button>
    </div>
  </form>
  
  <div class="back-link">
    <a href="/">Back</a>
  </div>
</div>

<style>
  .invitation-container {
    max-width: 500px;
    margin: 0 auto;
    padding: 2rem 1rem;
  }
  
  h1 {
    font-size: 1.875rem;
    font-weight: 600;
    margin-bottom: 1.5rem;
  }
  
  .notice {
    color: green;
    margin-bottom: 1rem;
    padding: 0.5rem;
    background-color: #ecfdf5;
    border-radius: 0.375rem;
  }
  
  .error-summary {
    background-color: #fee2e2;
    border: 1px solid #ef4444;
    border-radius: 0.375rem;
    padding: 1rem;
    margin-bottom: 1.5rem;
  }
  
  .error-summary h2 {
    color: #b91c1c;
    font-size: 1rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }
  
  .error-summary ul {
    margin: 0;
    padding-left: 1.25rem;
    color: #b91c1c;
  }
  
  .form-group {
    margin-bottom: 1.25rem;
  }
  
  .form-label {
    display: block;
    font-weight: 500;
    margin-bottom: 0.375rem;
  }
  
  .form-input {
    width: 100%;
    padding: 0.625rem;
    border: 1px solid #d1d5db;
    border-radius: 0.375rem;
    font-size: 1rem;
  }
  
  .form-input.error {
    border-color: #ef4444;
    background-color: #fef2f2;
  }
  
  .error-message {
    color: #ef4444;
    font-size: 0.875rem;
    margin-top: 0.25rem;
  }
  
  .form-actions {
    margin-top: 1.5rem;
  }
  
  .invitation-button {
    background-color: #047857;
    color: white;
    border: none;
    padding: 0.625rem 1.25rem;
    border-radius: 0.375rem;
    font-weight: 500;
    font-size: 1rem;
    cursor: pointer;
  }
  
  .invitation-button:hover {
    background-color: #065f46;
  }
  
  .back-link {
    margin-top: 1.5rem;
  }
  
  .back-link a {
    color: #047857;
    text-decoration: none;
  }
  
  .back-link a:hover {
    text-decoration: underline;
  }
</style>